const style = {
  box: {
    component: 'main',
    sx: {
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
  },
  container: {
    maxWidth: 'sm',
    sx: {
      py: {
        xs: '100px',
        md: '200px',
      },
    },
  },
  card: {
    elevation: 16,
    sx: { p: 4 },
  },
} as const;

export default style;
